<p>global-error-handler works!</p>
